import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"

import "./quasar"
import Vuelidate from 'vuelidate'

import mixins from "@/plugins/mixins"
import filters from "@/plugins/filters"

import Axios from 'axios'
import apiEndpoints from "./api/api-endpoints"

import reCaptchaPlugin from '@/plugins/vue-recaptcha-v3';

Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)
Vue.prototype.$http = Axios
const token = JSON.parse(localStorage.getItem('token'))
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = token?.access_token
}

Vue.use(Vuelidate)
Vue.use(mixins)
Vue.use(filters)
Vue.use(reCaptchaPlugin);
Vue.config.productionTip = false

if (!process.env.VUE_APP_ISTESTSITE) {
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
}

Vue.config.errorHandler = function (err, vm, info) {
    // handle error
    // `info` is a Vue-specific error info, e.g. which lifecycle hook
    // the error was found in. Only available in 2.2.0+
    console.log(err)
    console.log(vm)
    console.log(info)

    const errorPayload = {
        message: err.message,
        stack: err.stack,
        info: info,
        component: vm ? vm.$options.name || vm.$options._componentTag : undefined,
        propsData: vm ? vm.$options.propsData : undefined
    };

    Axios.post(apiEndpoints.notifyError, { 'data': errorPayload })
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        });

    router.push('/error')
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#q-app")
